export default () => {
  window.__APPS__ = window.__APPS__ || {};
  window.__APPS__.partner_page = {
    version: PARTNER_PAGE_VERSION // eslint-disable-line
  };
};
